export default __webpack_public_path__ + "static/media/quote-ic.e5c9e8b4.svg";